
window.addEventListener('load', function() {
	  const menuItems = document.querySelectorAll('.menu-item-has-children');

	  menuItems.forEach(menuItem => {
		menuItem.addEventListener('mouseover', () => {
		  menuItem.classList.add('show');
		});

		menuItem.addEventListener('mouseout', () => {
		  setTimeout(() => {
			menuItem.classList.remove('show');
		  }, 50);
		});
	  });
});

$(document).ready(function(){
	$('.menu-button').on('click', function(){
		$(this).toggleClass('opened');
		$('#mobile-main-nav').toggleClass('opened');
	});

	$('#mobile-main-nav .menu-item-has-children > a').on('click', function(e){
		e.preventDefault();
	});

	$('.menu-item-has-children').on('click', function(e){
		$(this).toggleClass('opened');
	});

	if ( $('nav.sub-menu-block .wp-block-navigation__container .current-menu-item').length ) {
		let svg = '<svg class="subnav_marker" width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-outside-1_3090_158038" maskUnits="userSpaceOnUse" x="0.710937" y="-0.503174" width="14" height="9" fill="black"><rect fill="white" x="0.710937" y="-0.503174" width="14" height="9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.50085 7.67531L13.7109 1.34236L12.8818 0.496826L7.50085 5.98425L2.1199 0.496826L1.29077 1.34236L7.50085 7.67531Z"/></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M7.50085 7.67531L13.7109 1.34236L12.8818 0.496826L7.50085 5.98425L2.1199 0.496826L1.29077 1.34236L7.50085 7.67531Z" fill="#FF00FF"/><path d="M13.7109 1.34236L13.8823 1.51039L14.0471 1.34236L13.8823 1.17432L13.7109 1.34236ZM7.50085 7.67531L7.32949 7.84334L7.50085 8.01809L7.67221 7.84334L7.50085 7.67531ZM12.8818 0.496826L13.0532 0.328791L12.8818 0.154041L12.7105 0.328791L12.8818 0.496826ZM7.50085 5.98425L7.32949 6.15228L7.50085 6.32703L7.67221 6.15228L7.50085 5.98425ZM2.1199 0.496826L2.29126 0.328791L2.1199 0.154041L1.94854 0.328791L2.1199 0.496826ZM1.29077 1.34236L1.11941 1.17432L0.954635 1.34236L1.11941 1.51039L1.29077 1.34236ZM13.5396 1.17432L7.32949 7.50727L7.67221 7.84334L13.8823 1.51039L13.5396 1.17432ZM12.7105 0.664861L13.5396 1.51039L13.8823 1.17432L13.0532 0.328791L12.7105 0.664861ZM7.67221 6.15228L13.0532 0.664861L12.7105 0.328791L7.32949 5.81621L7.67221 6.15228ZM1.94854 0.664861L7.32949 6.15228L7.67221 5.81621L2.29126 0.328791L1.94854 0.664861ZM1.46213 1.51039L2.29126 0.664861L1.94854 0.328791L1.11941 1.17432L1.46213 1.51039ZM7.67221 7.50727L1.46213 1.17432L1.11941 1.51039L7.32949 7.84334L7.67221 7.50727Z" fill="#FF00FF" mask="url(#path-1-outside-1_3090_158038)"/></svg>';
		$('nav.sub-menu-block .wp-block-navigation__container .current-menu-item').append(svg);
	}

	$("body").on('click','nav.sub-menu-block .wp-block-navigation__container .current-menu-item a', function(e){
		e.preventDefault();
		let container = $(this).parents('.wp-block-navigation__container')[0];
		$(container).toggleClass("opened");
	});

});